$(function () {

    'use strict';

    $.getJSON(`/rivaliq-settings.json?settingsCacheKey=${window.settingsCacheKey}`, function (settings) {
        RivalIQ.apps.Shell.execute('show:app', {
            app: RivalIQ.apps.Registration,
            options: {
                title: 'Registration',
                user: settings.user,
                focusCompanyUrl: window.focusCompanyUrl,
                isAgency: window.isAgency,
                trackSignUp: window.trackSignUp
            }
        });
    });
});
